module.exports = "\n<app-bookmarked-item-list ></app-bookmarked-item-list>\n<app-footer></app-footer>"


//////////////////
// WEBPACK FOOTER
// ./src/app/feature/main/roles-shared/components/all-bookmark-list/all-bookmark-list.component.html
// module id = ./src/app/feature/main/roles-shared/components/all-bookmark-list/all-bookmark-list.component.html
// module chunks = main